<template>
	<header-block title="All documents"></header-block>
	<div v-if="!(customer && documents)" class="mt-5">
		<v-skeleton-loader width="100%" type="text" class="mb-4" />
		<v-skeleton-loader width="100%" type="card" class="mb-3" />
		<v-skeleton-loader width="100%" type="card" class="mb-3" />
		<v-skeleton-loader width="100%" type="card" class="mb-3" />
		<v-skeleton-loader width="100%" type="card" />
	</div>
	<transition>
		<div v-if="customer && documents">

			<!-- Search bar -->
			<div class="search-bar">
				<v-text-field
					v-model="searchQuery"
					prepend-inner-icon="mdi-magnify"
					density="compact"
					label="Search documents"
					variant="solo"
					:flat="true"
					hide-details
					clearable
					single-line
					bg-color="#eeeeee"
				/>
			</div>

			<!-- Empty state -->
			<p v-if="filteredGroups.length === 0" class="empty-text">No documents found</p>

			<!-- Month-grouped document rows -->
			<template v-for="group in filteredGroups" :key="group.monthLabel">
				<p class="month-label">{{ group.monthLabel }}</p>
				<div class="month-rows">
					<div
						v-for="doc in group.docs"
						:key="doc.id"
						class="doc-row"
						@click="$router.push('/Documents/' + doc.id)"
					>
						<div class="doc-info">
							<p class="doc-company">{{ doc.company || doc.documentSubject }}</p>
							<p class="doc-filename">{{ doc.documentName }}</p>
							<p class="doc-added">Added {{ formatDate(doc.createDateTime) }}</p>
							<p v-if="doc.documentSubject" class="doc-label">{{ doc.documentSubject }}</p>
						</div>
						<img :src="require('@/assets/arrow-right.png')" class="doc-arrow" />
					</div>
				</div>
			</template>

			<div style="clear:both; padding-bottom: 110px;"></div>
		</div>
	</transition>
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';

export default {
	mixins: [Services],
	components: { HeaderBlock },
	data() {
		return {
			searchQuery: '',
		};
	},
	computed: {
		sorted() {
			if (!this.documents) return [];
			return [...this.documents].sort((a, b) => new Date(b.createDateTime) - new Date(a.createDateTime));
		},
		filteredGroups() {
			const q = (this.searchQuery || '').toLowerCase().trim();
			const docs = q
				? this.sorted.filter(doc =>
					(doc.company || '').toLowerCase().includes(q) ||
					(doc.documentName || '').toLowerCase().includes(q) ||
					(doc.documentSubject || '').toLowerCase().includes(q)
				)
				: this.sorted;

			const groups = [];
			const map = {};

			docs.forEach(doc => {
				const d = new Date(doc.createDateTime);
				const label = d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });

				if (!map[label]) { map[label] = { monthLabel: label, docs: [] }; groups.push(map[label]); }
				map[label].docs.push(doc);
			});

			return groups;
		},
	},
	methods: {
		getCustomer() {
			this._getCustomer(() => {
				this._getDocuments(() => {});
			});
		},
		onLoad() {
			this.getCustomer();
		},
		formatDate(dateStr) {
			if (!dateStr) return '';
			const d = new Date(dateStr);
			return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
		},
	},
	mounted() {
		this.onLoad();
	},
};
</script>

<style scoped>
/* Search bar */
.search-bar {
	margin-bottom: 24px;
}

/* Month label */
.month-label {
	font-size: 16px;
	font-weight: bold;
	color: var(--brand-purple);
	margin: 0 0 12px;
}

/* Rows within a month group */
.month-rows {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 24px;
}

/* Document row */
.doc-row {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	background: white;
	border-radius: 8px;
	border: 1px solid rgba(65, 54, 85, 0.1);
	box-shadow: 0px 4px 8px 0px rgba(51, 40, 71, 0.05);
}

.doc-info {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.doc-info p {
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.doc-company {
	font-size: 13px;
	font-weight: bold;
	color: var(--brand-purple);
}

.doc-filename {
	font-size: 12px;
	color: var(--brand-purple);
}

.doc-added {
	font-size: 12px;
	color: var(--brand-purple);
	opacity: 0.5;
}

.doc-label {
	font-size: 11px;
	font-weight: bold;
	color: var(--brand-purple);
}

.doc-arrow {
	width: 16px;
	height: 12px;
	flex-shrink: 0;
}

.empty-text {
	font-size: 13px;
	color: var(--light-text-secondary);
	margin: 0;
	text-align: center;
}
</style>
